import React, { ButtonHTMLAttributes, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import classNames from 'classnames';
import capitalize from 'lodash.capitalize';
import { TextButtonTheme } from '../theme/ColorSystem';

interface TextButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    color?: 'default' | 'primary' | 'secondary' | 'danger';
    children: ReactNode;
    ref?: React.Ref<HTMLButtonElement>;
}

const colorCss = (color: 'default' | 'primary' | 'secondary' | 'danger') => css`
    color: ${TextButtonTheme[color].active};

    &:hover {
        color: ${TextButtonTheme[color].hover};
    }
    &:focus {
        color: ${TextButtonTheme[color].focus};
        outline: none;
    }
    &[disabled] {
        color: ${TextButtonTheme[color].disabled};
    }
`;

const StyledTextButton = styled.button`
    background: transparent;
    border: none;
    font-size: 1rem;
    font-weight: 600;
    text-transform: none;
    cursor: pointer;
    padding: 1rem 1rem;
    outline: none;
    letter-spacing: 0.34px;
    line-height: 24px;

    &.textButtonDefault {
        ${colorCss('default')}
    }
    &.textButtonPrimary {
        ${colorCss('primary')}
    }
    &.textButtonSecondary {
        ${colorCss('secondary')}
    }
    &.textButtonDanger {
        ${colorCss('danger')}
    }
`;

// eslint-disable-next-line react/display-name
const TextButton: React.FC<TextButtonProps> = React.forwardRef<HTMLButtonElement, TextButtonProps>(
    ({ color = 'default', children, className, ...others }, ref) => {
        return (
            <StyledTextButton
                ref={ref}
                {...others}
                className={classNames(
                    `textButton${capitalize(color)}`,
                    `text-btn-${color}`,
                    className,
                )}
                type="button"
            >
                {children}
            </StyledTextButton>
        );
    },
);
export default TextButton;
